// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-panel {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 500px;
    margin: 20px auto;
    padding: 20px;
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 8px;
}

.admin-panel h1 {
    text-align: center;
    margin-bottom: 20px;
    color: #333;
}

.tabs {
    display: flex;
    justify-content: center;
    gap: 10px;
    border-bottom: 1px solid #ccc;
    margin-bottom: 20px;
}

.tabs button {
    background: none;
    border: none;
    padding: 10px 15px;
    font-size: 16px;
    color: #333;
    cursor: pointer;
    transition: background-color 0.3s, border-bottom 0.3s;
    border-bottom: 2px solid transparent;
    outline: none;
}

.tabs button:hover {
    background-color: #f2f2f2;
}

.tabs button.active {
    border-bottom: 2px solid #007bff;
    font-weight: bold;
}

.tab-content {
    height: 400px;
    overflow-y: auto;
    background-color: #f9f9f9;
    border: 1px solid #ddd;
    border-radius: 4px;
    padding: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/AdminPanel.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,YAAY;IACZ,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,eAAe;IACf,qDAAqD;IACrD,oCAAoC;IACpC,aAAa;AACjB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gCAAgC;IAChC,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;AACjB","sourcesContent":[".admin-panel {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: 500px;\n    margin: 20px auto;\n    padding: 20px;\n    background-color: #fff;\n    border: 1px solid #ccc;\n    border-radius: 8px;\n}\n\n.admin-panel h1 {\n    text-align: center;\n    margin-bottom: 20px;\n    color: #333;\n}\n\n.tabs {\n    display: flex;\n    justify-content: center;\n    gap: 10px;\n    border-bottom: 1px solid #ccc;\n    margin-bottom: 20px;\n}\n\n.tabs button {\n    background: none;\n    border: none;\n    padding: 10px 15px;\n    font-size: 16px;\n    color: #333;\n    cursor: pointer;\n    transition: background-color 0.3s, border-bottom 0.3s;\n    border-bottom: 2px solid transparent;\n    outline: none;\n}\n\n.tabs button:hover {\n    background-color: #f2f2f2;\n}\n\n.tabs button.active {\n    border-bottom: 2px solid #007bff;\n    font-weight: bold;\n}\n\n.tab-content {\n    height: 400px;\n    overflow-y: auto;\n    background-color: #f9f9f9;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    padding: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
